import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classes from "./NavMenuItem.module.css";

const NavMenuItem = (props) => {
  const { label, to } = props;
  return (
    <li className={classes["nav-item"]} title={label}>
      <Link to={to}>{label}</Link>
    </li>
  );
};

export default NavMenuItem;

NavMenuItem.propTypes = {
  label: PropTypes.string,
  to: PropTypes.string,
};
